import { createReducer, on } from '@ngrx/store';
import {
  loadProcessingResults,
  loadProcessingResultsSuccess,
  loadProcessingResultsFailure,
  clearProcessingResults,
} from './processing-results.actions';
import { ProcessingResultsState } from '../../interfaces/state/reducers/processing-results-state.interface';

export const initialState: ProcessingResultsState = {
  items: [],
  loading: false,
  loadingMore: false,
  error: null,
  hasMoreData: false,
  bookmark: null,
  projectId: null,
};

export const processingResultsReducer = createReducer(
  initialState,
  on(loadProcessingResults, (state, { query }) => ({
    ...state,
    loading: !query.bookmark,
    loadingMore: !!query.bookmark,
    error: null,
    projectId: query.projectId,
  })),
  on(loadProcessingResultsSuccess, (state, { items, hasMoreData, bookmark, append }) => ({
    ...state,
    items: append ? [...state.items, ...items] : items,
    loading: false,
    loadingMore: false,
    hasMoreData,
    bookmark,
  })),
  on(loadProcessingResultsFailure, (state, { error, append }) => ({
    ...state,
    loading: append ? state.loading : false,
    loadingMore: false,
    error,
  })),
  on(clearProcessingResults, () => initialState)
);
